import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React from "react";
var __jsx = React.createElement;
import dynamic from "next/dynamic";
import Head from "next/head";
var Treasury = dynamic(function () {
  return import("components/treasury/Treasury");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("components/treasury/Treasury")];
    }
  }
});
function TreasuryPage() {
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "WRewards - Treasury")), __jsx(Treasury, null));
}
export var __N_SSP = true;
export default _withSuperJSONPage(TreasuryPage);